"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultBoxM = void 0;
var ResultBoxM = /** @class */ (function () {
    function ResultBoxM(typeResultBox, title, uri, image, predicates) {
        this.typeResultBox = typeResultBox;
        this.title = title;
        this.uri = uri;
        this.image = image;
        this.predicates = predicates;
    }
    ResultBoxM.prototype.addPredicate = function (predicate) {
        this.predicates.push(predicate);
    };
    return ResultBoxM;
}());
exports.ResultBoxM = ResultBoxM;
